@if (!hideHeader) {
    @if (!showGridPillsHeader) {
        <ms-grid-header
            [columns]="columns"
            [sport]="model.sport"
            [title]="title"
            [sorting]="model.sorting"
            [isSortingVisible]="!model.disableGroupSorting"
            [hideTitle]="hideTitle"
            [sortingTracking]="sortingTracking"
            [layout]="layout"
            [useColoredIcon]="useColoredIcon"
            [hideMarketSwitcher]="collapseSportHeaders ? !expandedSport[model.sport.id] : hideMarketSwitcher"
            [baseCount]="baseCount"
            [offerBadgeTemplate]="offerBadgeTemplate"
            [iconTemplate]="iconTemplate"
            [isSportHeaderCollapsed]="collapseSportHeaders ? !expandedSport[model.sport.id] : undefined"
            [eventsCount]="eventCount"
            [setMarketSwitcherHeight]="setMarketSwitcherHeight"
            [tracking]="tracking"
            [showRadioInputInSortSelector]="showRadioInputSortSelectorInHeader"
            [popperAppendTo]="popperAppendTo"
            [gridHeaderOverride]="gridHeaderOverride"
            (groupChange)="groupChanged($event)"
            (moreChange)="moreToggled($event)"
            (sortingChange)="changeSorting($event)"
            (toggleAccordion)="accordionCollapsed($event)" />
    } @else {
        <ms-grid-pills-header
            [column]="columns[0]"
            [sport]="model.sport"
            [hideTitle]="hideTitle"
            [useColoredIcon]="useColoredIcon"
            [tracking]="tracking"
            [sorting]="model.sorting"
            [sortingTracking]="sortingTracking"
            [iconTemplate]="iconTemplate"
            [gridHeaderOverride]="gridHeaderOverride"
            (pillChange)="groupChanged($event)"
            (sortingChange)="changeSorting($event)"
            (toggleAccordion)="accordionCollapsed($event)" />
    }
    @if (empty && emptyHeader) {
        <ms-error severity="info" [message]="emptyMessage" [links]="false" />
    }
}

@if (!collapseSportHeaders || (collapseSportHeaders && expandedSport[model.sport.id])) {
    <div>
        <ms-performance-tracker [trigger]="model.id" />
        @for (group of model.groups; track trackGroup($index, group)) {
            <ms-event-group
                [class.six-pack-groups]="layout === layoutType.SixPack"
                [style.--event-group-rows]="group.collapsed ? 0 : group.events.length"
                [msSwipeContainer]="swipeToggle"
                [columns]="columns"
                [group]="group"
                [grouping]="model.grouping"
                [sportId]="model.sport.id"
                [hideFavourites]="hideFavourites || hideHeaderRegion"
                [useColoredIcon]="useColoredIcon"
                [hideMarketHeader]="hideMarketHeader"
                [hideHeaderRegion]="hideHeaderRegion"
                [competitionFallbackIcon]="competitionFallbackIcon"
                [hideGroupCount]="hideGroupCount"
                [allowHeaderCollapse]="allowHeaderCollapse"
                (toggle)="groupToggled($event)">
                <ng-container *rxFor="let event of group.events; index as index; trackBy: trackEvent">
                    @switch (layout) {
                        @case (layoutType.SixPack) {
                            <ms-six-pack-event
                                [msSwipeActions]="swipeTemplate"
                                [swipeContext]="event"
                                [event]="event"
                                [groups]="groups"
                                [linkConfig]="linkConfig"
                                [media]="model.media"
                                [tracking]="trackingGameDetails(event, 'SixPack', index)"
                                [favouriteToggle]="favouriteToggle"
                                [promotedFixtureIdsMap]="promotedFixtureIdsMap"
                                [msAutomation]="getAutomationAttributes(event)"
                                [optionGroupTemplate]="optionGroupTemplate"
                                [showParticipantImage]="showParticipantImage"
                                [calendarInfoDisplay]="calendarInfoDisplay"
                                [showAllWagers]="showAllWagers"
                                [betDetails]="betDetails"
                                [showLogoColor]="true"
                                (click)="eventClicked(event, index)" />
                        }
                        @case (layoutType.Hybrid) {
                            <ms-compact-event
                                [event]="event"
                                [groups]="groups"
                                [media]="model.media"
                                [tracking]="trackingGameDetails(event, 'NonGridable', index)"
                                [state]="model.collapsed.events[event.id]"
                                [msAutomation]="getAutomationAttributes(event)"
                                [betDetails]="betDetails"
                                (click)="eventClicked(event, index)"
                                (collapse)="eventCollapsed(event.id, $event)" />
                        }
                        @default {
                            <ms-event
                                [msSwipeActions]="swipeTemplate"
                                [swipeContext]="event"
                                [event]="event"
                                [groups]="groups"
                                [linkConfig]="linkConfig"
                                [media]="model.media"
                                [tracking]="trackingGameDetails(event, 'NonGridable', index)"
                                [favouriteToggle]="favouriteToggle"
                                [promotedFixtureIdsMap]="promotedFixtureIdsMap"
                                [msAutomation]="getAutomationAttributes(event)"
                                [optionGroupTemplate]="optionGroupTemplate"
                                [showParticipantImage]="showParticipantImage"
                                [calendarInfoDisplay]="calendarInfoDisplay"
                                [showOptionname]="showOptionname"
                                [showAllWagers]="showAllWagers"
                                [betBuilderEpcotEnabled]="betBuilderEpcotEnabled"
                                [betDetails]="betDetails"
                                [showLogoColor]="true"
                                (click)="eventClicked(event, index)"
                                (statsClicked)="statsClicked.emit(event)"
                                (moreBetsClicked)="moreBetsClicked.emit(event)" />
                        }
                    }
                </ng-container>
            </ms-event-group>
        }
    </div>
}
<ng-template #swipeTemplate let-event let-close="close">
    <ms-favourite-event-toggle [event]="event" [static]="true" (toggle)="close()" />
    <div class="swipe-message">
        @if (event.favourited) {
            {{ sitecore.favouritesMessages.RemoveFavourite }}
        } @else {
            {{ sitecore.favouritesMessages.AddFavourite }}
        }
    </div>
</ng-template>
